import Logger from 'Logger'

import { popShow } from '../../../manager/mall.event'
import { pokerClassName } from '../../../utils/pokerClassName'
import { getPokerClass, setPokerClass } from '../../../config'
import { runGameOrGoScene, $number } from '../../../utils'

/*
샘플 응답값
{
    "requestId": "b248fd88-26d2-4682-b32d-27a23aed05d8",
    "result": {
        "result_code_extra_info": {
            "result_code": -10,
            "extra_info": null
        },
        "amt_remain": 926000,
        "simple_goods_info": [
            {
                "goods_id": 626453,
                "goods_name": "부스터",
                "price": 60000,
                "goods_bonus": 0,
                "goods_descr": null,
                "reward_money": 0,
                "auto_payment_goods": false,
                "eff_code": "boosterset",
                "shop_id": 106
            }
        ],
        "simple_goods_class_info": {
            "goods_id": 626452,
            "goods_name": "부스터",
            "price": 50000,
            "goods_bonus": 5000,
            "goods_descr": null,
            "eff_code": "boosterset"
        },
        "pmang_cash_url_info": {
            "HP": {
                "pay_buy_count_url": "https://",
                "pay_buy_now_count_url": "https://billqa.pmang.com/Crusader/rds.nwz?act=payBuyNow&buy_count=1&close_type=MI6&fingerprint=cbd3d500b74b5973bb85e0e8052d0cdb&location=NWZPMC0156&pay_type=HP&product_level=charge&saleinfo_id=683047&sayurl=https%3A%2F%2Fpoker.pmang.com%2F7poker%2Fconfirm-payment%3Fusn%3D144083283%26act%3DpayBuyNow%26goods_id_list%3D626453%26tracking_code%3Dp%7CShop_Web%7C0%26pms_code%3D1000&seed=3&site_id=GMS&site_srl=144083283&site_tid=144083283%3A1779097295&svc_code=PMANG&user_ip=203.215.207.189"
            },
            "NAVR": {
                "pay_buy_count_url": "https://",
                "pay_buy_now_count_url": "https://"
            },
            "NOCB": {
                "pay_buy_count_url": "https://",
                "pay_buy_now_count_url": "https://"
            },
            "KKAO": {
                "pay_buy_count_url": "https://",
                "pay_buy_now_count_url": "https://"
            },
            "BT": {
                "pay_buy_count_url": "https://",
                "pay_buy_now_count_url": "https://"
            },
            "PCO": {
                "pay_buy_count_url": "https://",
                "pay_buy_now_count_url": "https://"
            },
            "CARD": {
                "pay_buy_count_url": "https://",
                "pay_buy_now_count_url": "https://"
            }
        },
        "pmang_cash_info": {
            "amt_total": 5500,
            "amt_manual": 0,
            "amt_balance": 5500,
            "amt_ticket": 0,
            "amt_event": 0
        },
        "period_bonus_info": null,
        "pwg_point_info": null,
        "vip_coupon_info": [
            {
                "vip_coupon_id": 1,
                "coupon_name": "VIP 전용 쿠폰 (1%)",
                "bonus_money_rate": 1
            }
        ],
        "resultCode": -10
    }
}
*/

/**
 *  상품 구매 불가시 예외 팝업 호출
 * @param {Response} response ajax response 값
 * @param {*} payModel - pay 모델 참조
 */
export function itemGuard(response, payModel, resolve) {
  Logger.info('[ITEM_CONTROLLER]', response)

  const result = response.result
  const code = result.resultCode

  const extraInfo =
    result.result_code_extra_info && result.result_code_extra_info.extra_info

  setPokerClass(pokerClassName(extraInfo || getPokerClass()))

  const classNameKo = getPokerClass()

  const isBoosterClass =
    result.simple_goods_class_info &&
    result.simple_goods_class_info.eff_code === 'boosterset' // 부스터 정기권 구매시에는 객체 형태

  const isBoosterGoods =
    Array.isArray(result.simple_goods_info) &&
    result.simple_goods_info.some(
      (item) => item.eff_code === 'boosterset' // 부스터 개월권 구매시에는 배열 형태
    )
  const isBooster = isBoosterClass || isBoosterGoods // 부스터 정기권 or 부스터 개월권

  const unreceivedMoney =
    result.period_bonus_info && result.period_bonus_info.eff_value

  const onclose = function () {
    this.hide()
    payModel.hide()
  }

  Logger.info('[ITEM_GUARD]', 'code:', code)

  switch (code) {
    case 1:
      // 클래스 데일리 머니 미수령 금액이 있을 경우
      if (unreceivedMoney && unreceivedMoney > 0) {
        var totalUnreceivedDailyMoney = $number(
          Number(unreceivedMoney) || 0
        ).text()

        var unreceivedMessage = totalUnreceivedDailyMoney
          ? '<br /><span>(잔여 데일리 머니 ' +
            totalUnreceivedDailyMoney +
            ')</span>'
          : ''

        var warning =
          '<br/><br/><span class="extra">2025년 8월 26일 이전 클래스 이용자는 해당 결제 시,<br/>섯다에 지급되던 혜택이 종료될 수 있습니다.<br/> 또한 기존 클래스가 중복 결제 되지 않았는지 꼭 확인해주세요. </span>'

        popShow({
          title: '사용 중 추가 구매 안내',
          message:
            '사용 중인 클래스의 모든 혜택이<br />구매하는 클래스로 변경됩니다.<br /><br />잔여 데일리 머니는 선물함에 합산됩니다.' +
            unreceivedMessage +
            warning,
          closeText: '취소',
          confirmText: '구매하기',
          confirmBtnColor: 'red',
          onClose: onclose,
          onConfirm: function () {
            this.hide()
            resolve(response)
          },
        })
      } else {
        resolve(response)
      }
      break

    case 2:
      // 클래스(부스터) 개월권 연장 구매: 만기 6일 미만 전부터 구매 가능
      if (isBooster) {
        popShow({
          title: '부스터 연장 구매',
          message: '부스터 추가 구매 시 이용 기간이 연장됩니다.',
          closeText: '취소',
          confirmText: '구매하기',
          confirmBtnColor: 'red',
          onClose: onclose,
          onConfirm: function () {
            this.hide()
            resolve(response)
          },
        })
      } else {
        popShow({
          title: '클래스 연장 구매',
          message: classNameKo + ' 추가 구매 시 이용 기간이 연장됩니다.',
          closeText: '취소',
          confirmText: '구매하기',
          confirmBtnColor: 'red',
          onClose: onclose,
          onConfirm: function () {
            this.hide()
            resolve(response)
          },
        })
      }
      break

    case 0:
      popShow({
        title: '안내',
        message: '서버에 문제가 있습니다. <br /> 잠시 후 다시 시도해 주세요.',
        onClose: onclose,
      })
      throw new Error('상품 상세 조회 에러')

    case -2:
      popShow({
        title: '구매한도 초과',
        message: '구매 한도를 초과하여 더 이상 선택할 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('구매한도 초과')

    case -4:
      popShow({
        title: '구매개수 초과',
        message: '더 이상 구매할 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('구매개수 초과')

    case -6:
      if (isBooster) {
        popShow({
          title: '부스터 이용 중',
          message: '이미 부스터 정기결제를 이용 중입니다.',
          confirmText: '이용정보 보기',
          confirmBtnColor: 'gray',
          onConfirm: function () {
            runGameOrGoScene()
            resolve(response)
          },
          onClose: onclose,
        })
      } else {
        popShow({
          title: classNameKo + ' 이용 중',
          message: '이미 ' + classNameKo + ' 정기결제를 이용 중입니다.',
          confirmText: '이용정보 보기',
          confirmBtnColor: 'gray',
          onConfirm: function () {
            runGameOrGoScene()
            resolve(response)
          },
          onClose: onclose,
        })
      }

      throw new Error('같은 클래스(부스터) 이용 중')

    case -7:
      if (isBooster) {
        popShow({
          title: '부스터 이용 중',
          message:
            '이미 부스터 정기결제를 이용 중입니다. <br /> <span>정기결제 구독 취소 후 <br />이용 기간이 만료되면 구매할 수 있습니다. </span>',
          confirmText: '이용정보 보기',
          confirmBtnColor: 'gray',
          onConfirm: function () {
            runGameOrGoScene()
            resolve(response)
          },
          onClose: onclose,
        })
      } else {
        popShow({
          title: classNameKo + ' 이용 중',
          message:
            '이미 ' +
            classNameKo +
            ' 정기결제를 이용 중입니다. <br /> <span>정기결제 구독 취소 후 <br />이용 기간이 만료되면 구매할 수 있습니다. </span>',
          confirmText: '이용정보 보기',
          confirmBtnColor: 'gray',
          onConfirm: function () {
            runGameOrGoScene()
            resolve(response)
          },
          onClose: onclose,
        })
      }
      throw new Error('모바일 클래스 보유자가 상위 클래스 구매')

    case -8:
      Logger.info('금고이용권 사용중', result.result_code_extra_info.extra_info)
      // result.result_code_extra_info.extra_info 금고이용권 사용 남은 기간 나옴
      break

    case -9:
      popShow({
        title: '안내',
        message: '준비된 상품이 모두 소진되었습니다.',
        onClose: onclose,
      })
      throw new Error('핫딜 구매 불가')

    case -10:
      if (isBooster) {
        popShow({
          title: '부스터 이용 중',
          message:
            '이미 부스터 정기결제를 이용 중입니다. <br /> <span>정기결제 구독 취소 후 <br />이용 기간이 만료되면 구매할 수 있습니다. </span>',
          confirmText: '이용정보 보기',
          confirmBtnColor: 'gray',
          onConfirm: function () {
            runGameOrGoScene()
            resolve(response)
          },
          onClose: onclose,
        })
      } else {
        popShow({
          title: classNameKo + ' 이용 중',
          message:
            '이미 ' +
            classNameKo +
            ' 정기결제를 이용 중입니다. <br /> <span>정기결제 구독 취소 후 <br />이용 기간이 만료되면 구매할 수 있습니다. </span>',
          confirmText: '이용정보 보기',
          confirmBtnColor: 'gray',
          onConfirm: function () {
            runGameOrGoScene()
            resolve(response)
          },
          onClose: onclose,
        })
      }

      throw new Error('모바일 클래스 보유자가 상위 클래스 구매')

    case -11:
      popShow({
        title: '클래스 변경 구매',
        message:
          '골드클래스 이용 중에는 <br /> 실버클래스를 구매할 수 없습니다.<br /><span>골드클래스 기간 종료 후 구매하세요.</span>',
        onClose: onclose,
      })
      throw new Error('모바일 클래스 보유자가 상위 클래스 구매')

    case -12:
      var remainDay = result.result_code_extra_info.extra_info
      popShow({
        title: '연장 구매 안내',
        message:
          '남은 기간이 <b>5</b>일 이하인 경우<br /> 연장 구매가 가능합니다. (<b>' +
          remainDay +
          '</b>)일 남음',
        onClose: onclose,
      })
      throw new Error(
        '모바일 클래스 보유자가 상위 클래스 구매 또는 부스터 보유자가 부스터 추가 구매시'
      )

    case -14:
      popShow({
        title: '안내',
        message:
          '이미 보유하신 클래스가 있습니다. <br />' +
          '게임을 실행하여 <br />' +
          '해당 클래스 혜택을 받으세요.',
        confirmText: '게임 실행하기',
        confirmBtnColor: 'red small-txt',
        onConfirm: function () {
          runGameOrGoScene()
          resolve(response)
        },
        closeBtnColor: 'gray',
        closeText: '확인',
        onClose: onclose,
      })
      throw new Error(
        '클래스 구매 후 효력을 받지 않은(게임을 실행하지 않은) 회원'
      )

    case -15:
      popShow({
        title: '안내',
        message: '결제 예정일에는 골드클래스로<br />업그레이드 할 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('정기결제 결제 예정일에 상위 클래스 구매 시도')

    case -21:
      popShow({
        title: '게임 실행 중',
        message: '게임 실행 중에는 <br />포커몰을 이용할 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('모바일 클래스 보유자가 상위 클래스 구매')

    case -16:
      popShow({
        title: (classNameKo || '클래스') + ' 이용 중',
        message: '클래스 이용 중에는<br />구매할 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('클래스 보유 중 세트 아이템 구매 시도') // 모듬세트, 실속세트

    case -17:
      popShow({
        title: '구매 불가',
        message: '실속세트 이용 중에는<br />구매할 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('세트 보유 중 클래스 구매 시도')

    case -18:
      popShow({
        title: '선물하기 불가',
        message: '선물하기를 할 수 없는 회원입니다.<br />(모듬세트 이용 회원)',
        onClose: onclose,
      })
      throw new Error('선물 받는 회원 세트 아이템 효력 보유')

    // 구글 유예기간, iOS 보류기간
    case -19:
      popShow({
        title: '안내',
        message: [
          '기존 클래스상품이 결제유예 상태이므로,',
          '다른 클래스상품을 구매할 수 없습니다.',
          '<span>정기결제를 구매한 플랫폼에서',
          '결제 정보를 확인해주세요.</span>',
        ].join('<br />'),
        onClose: onclose,
      })
      throw new Error('구글 유예기간, iOS 보류기간')

    // 실속세트 10개 이상 이용유저가 “구매하기” 버튼을 눌러 구매 시도 시
    case -20:
      popShow({
        title: '구매 불가',
        message: '최대 10개까지만<br/>구매하실 수 있습니다.',
        onClose: onclose,
      })
      throw new Error('세트 구매 제한')

    //  구매한도 초과 대응
    case 4: // 성공 (머니 한도초과 이지만, 클래스 구매가 가능하여 구매 가능한 경우)
      popShow({
        title: '한도 초과 안내',
        message:
          '보유한도를 초과한 머니는<br />초과머니로 지급됩니다.<br /><br />구매를 진행하시겠습니까?',
        closeText: '취소',
        confirmText: '구매하기',
        confirmBtnColor: 'red',
        onClose: onclose,
        onConfirm: function () {
          this.hide()
          resolve(response)
        },
      })
      break

    // 머니 한도초과인 상태에서 골드클래스인 경우(클래스 구매 불가)
    case -32:
      popShow({
        title: '한도 초과 안내',
        message: '구매 시 머니 보유한도가 초과되어<br />구매하실 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('머니 보유한도 추가')

    // 2022-03 셀프케어 구매한도 제한 설정시
    case -33:
      popShow({
        title: '구매 실패',
        message:
          '설정한 월구매금액을<br />초과하여 결제할 수 없습니다.<br /><br /><span>월구매금액 변경은 내정보&gt;셀프케어에서 가능합니다.</span>',
        onClose: onclose,
      })
      throw new Error('셀프케어 구매한도 초과')

    // 2022년 12월: GAMECS-817 => 몰을 열어둔 상태에서 보안 서비스 인증 시간 만료
    case -5:
      popShow({
        title: '보안서비스 안내',
        message:
          '보안서비스 인증을 위해 페이지를 새로고침 합니다.<br />새로고침 후 다시 시도해 주세요.',
        closeText: '새로고침',
        onClose: function () {
          window.location.reload()
        },
      })
      throw new Error('보안서비스 인증 만료')

    // 2023년 1월 : PRODPOKER-9867
    case -34:
      popShow({
        title: '구매 불가',
        message:
          '블랙리스트로 등록 가능한 최대 인원을<br /> 초과하여 구매할 수 없습니다.<br /><span>(블랙리스트 최대 인원 1000명)</span>',
        onClose: onclose,
      })
      throw new Error('블랙리스트 동록 가능 인원 초과')

    // 2023년 5월 : PRODPOKER-9912
    case -22:
      popShow({
        title: '구매 불가',
        message: '실속세트 이용중에는<br />구매할 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('실속세트 보유 중 클래스 구매 시도')

    // 2026년 5월
    case -37:
      popShow({
        title: '부스터 이용 중',
        message: '부스터 이용 중에는<br />구매할 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('부스터 이용 중 실속세트 구매 불가')

    // 2026년 5월
    case -38:
      popShow({
        title: '실속세트 이용 중',
        message: '실속세트 이용 중에는<br />구매할 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('실속세트 이용 중 부스터 구매 불가')

    case -39:
      popShow({
        title: '부스터 이용 중',
        message: '부스터 이용 중에는<br />구매할 수 없습니다.',
        onClose: onclose,
      })
      throw new Error('부스터 개월권 이용 중 정기권 구매 불가')

    default:
      popShow({
        title: '죄송합니다',
        message: '정의되지 않은 오류 코드 : ' + code,
        onClose: onclose,
      })
      throw new Error('정의되지 않은 오류')
  }
}
